import { Component } from '@angular/core';
import { UiDaysBeforeDeliveryComponent } from '../ui-days-before-delivery.component';

@Component({
  standalone: false,
  selector: 'ui-in-days-count',
  templateUrl: './ui-in-days-count.component.html'
})
export class UiInDaysCountComponent extends UiDaysBeforeDeliveryComponent {
}

